import NavigationBar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "@/pages/home/components/Hero";
import CategoryGate from "@/pages/home/components/CategoryGate";
import HotBoard from "@/pages/home/components/HotBoard";
import LatestFeed from "@/pages/home/components/LatestFeed";
import CategorySpotlight from "@/pages/home/components/CategorySpotlight";
import FaqPreview from "@/pages/home/components/FaqPreview";
import { useSeo } from "@/hooks/useSeo";
import { getLatestArticles, siteInfo } from "@/utils/content";

export default function Home() {
  useSeo({
    title: "511爆料 - 分类导航快速直达入口｜娱乐圈瓜·职场瓜·校园瓜·同城瓜",
    description:
      "511爆料分类导航覆盖娱乐圈瓜、职场瓜、校园瓜、同城瓜、行业瓜，分类清晰更新快，热门小众都能找到，想吃哪类瓜直接进，按图索骥不迷路。",
    keywords: "511爆料,511爆料娱乐圈瓜,511爆料职场瓜,511爆料校园瓜,511爆料同城瓜,511爆料行业瓜",
    canonical: "/",
    type: "website",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20dark%20cinematic%20abstract%20city%20rooftop%20at%20night%20with%20warm%20coral%20neon%20glow%20and%20floating%20geometric%20shapes%2C%20moody%20atmosphere%20with%20deep%20shadows%20for%20text%20contrast%2C%20editorial%20poster%20art%2C%20no%20people&width=1600&height=900&seq=hero-511-baoliao&orientation=landscape",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "511爆料",
        url: siteInfo.baseUrl,
        description: siteInfo.intro,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: `${siteInfo.baseUrl}/category/all?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "511爆料",
        url: siteInfo.baseUrl,
        email: siteInfo.email,
        description: "以分类导航为核心的爆料内容门户，覆盖娱乐圈、职场、校园、同城与行业五大领域。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "最新爆料",
        itemListElement: getLatestArticles(6).map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.title,
          url: `${siteInfo.baseUrl}/article/${item.id}`,
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <NavigationBar />
      <main className="flex-1">
        <Hero />
        <CategoryGate />
        <HotBoard />
        <LatestFeed />
        <CategorySpotlight />
        <FaqPreview />

        <section className="w-full bg-secondary-700 py-14 md:py-16">
          <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-4 md:flex-row md:items-center md:justify-between md:px-8">
            <div>
              <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                有想补充的观察或细节？
              </h2>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-secondary-100">
                我们更欢迎带有真实场景和具体细节的投稿。写清楚时间、场景和你的身份视角，
                编辑部会协助做脱敏处理后再发布。
              </p>
            </div>
            <a
              href={`mailto:${siteInfo.email}`}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-mail-send-line" />
              投稿与联系
            </a>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}